export default "__VITE_ASSET__CxPR7H$Y__"